<script lang="ts" setup>
import { onMounted, ref, watch } from "vue";
import { useMate } from "@/stores/mate";
import { useRouteParams } from "@vueuse/router";
import MateHomeUser from "./MateHomeUser.vue";
import MateHomeMate from "./MateHomeMate.vue";
import type { Component } from "vue";
import {
  sessionStorageGet,
  sessionStorageRemove,
} from "@/tools/sessionStorage";
import { useRoute } from "vue-router";
import { Mate } from "@/types/entity";
// 常量
// 状态
const mateStore = useMate();

const isLoading = ref(false);
const mateUuid = useRouteParams<string>("uuid");
const component1 = ref<Component | null>(null);

const route = useRoute();
const mate = ref<Mate | null>(null);

watch(
  () => route,
  async (newRoute) => {
    const { params, name } = newRoute;
    const { uuid } = params;
    let _uuid = "";
    if (uuid && name === "mateHome") {
      mateStore.getOrFetchMate(uuid as string, true);
    }
    if (name === "myMate" && mateUuid.value !== mateStore.currentMate!.uuid) {
      _uuid = mateStore.currentMate!.uuid;
    } else if (name === "mateHome" && uuid && mate.value?.uuid !== uuid) {
      _uuid = uuid as string;
    }
    if (
      sessionStorageGet("reloadMateHome") &&
      (name === "myMate" ||
        (name === "mateHome" && uuid === mateStore.currentMate!.uuid))
    ) {
      _uuid = mateStore.currentMate!.uuid;
      sessionStorageRemove("reloadMateHome");
    }
    if (_uuid) reloadPage(_uuid);
  },
  {
    deep: true,
  }
);

// LifeCycle
const reloadPage = async (uuid?: string) => {
  if (!uuid) return;
  isLoading.value = true;
  component1.value = null;
  try {
    const _mate = await mateStore.getOrFetchMate(uuid!);

    mate.value = _mate;
    component1.value = _mate.isUser ? MateHomeUser : MateHomeMate;
    isLoading.value = false;
  } catch (e) {
    isLoading.value = false;
  }
};

onMounted(() => {
  reloadPage(mateUuid.value);
});
</script>
<template>
  <div class="overflow-hidden h-full">
    <template v-if="isLoading">
      <ThreadsNav show-back :show-center="false" />
      <div class="flex items-center justify-center">
        <span class="loading loading-ring"></span>
      </div>
    </template>
    <template v-else-if="component1">
      <component :is="component1" :mate="mate" />
    </template>
    <template v-else>
      <ThreadsNav show-back :show-center="false" />
      <VanEmpty :description="$t(`Message.noPermissionToViewRole`)"></VanEmpty>
    </template>
  </div>
</template>
